import React from "react";
import { Route, Redirect } from "react-router-dom";
import { sessionService } from "../../Shared/Utils/SessionService";
import { handleLogout } from "../../../src/Shared/Utils/CommonUtils";

const ProtectedRoute = ({ auth, match, component: Component, ...rest }) => {
  const setRoute = () => {
    let isAuth = !!localStorage.getItem('cpcb-user');
    console.log(window.location.pathname)
    const tokenString = localStorage.getItem('cpcb-user');
    const userData = JSON.parse(localStorage.getItem('cpcb-user'));
    const role = userData?.role[0];
    if (!tokenString) {
      if (rest?.path === '/login') {
        isAuth = true;
      }
      else
        isAuth = false;
    } else {
      if (rest?.path === '/complaints-list') {
        if (role === 'rdo' || role === 'state' || role === 'cpcb') {
          isAuth = false;
        }
      } else if (rest?.path === '/ro-home') {
        if (role === 'ulb' || role === 'state' || role === 'cpcb') {
          isAuth = false;
        }
      } else if (rest?.path === '/state-home') {
        if (role === 'ulb' || role === 'rdo' || role === 'cpcb') {
          isAuth = false;
        }
      } else if (rest?.path === '/admin-home') {
        if (role === 'ulb' || role === 'rdo' || role === 'state') {
          isAuth = false;
        }
      }
      else {
        isAuth = true;
      }
    }
    return isAuth;
  }
  return (<>
    <Route {...rest} render={(props) => {
      const isAuth = setRoute();
      if (isAuth === true) {
        if (props.location.pathname === '/login') {
          sessionService.clearSession("cpcb-user");
          handleLogout();
        }
        return <Component {...props} />
      }
      else {
        sessionService.clearSession("cpcb-user");
        handleLogout(); // clearing the cookie
        return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
      }
    }} />

  </>
  );
};

export default ProtectedRoute;